import { registerIconLibrary } from "@web.awesome.me/webawesome-pro/dist/webawesome.js";
import "@web.awesome.me/webawesome-pro/dist/components/page/page.js";
import "@web.awesome.me/webawesome-pro/dist/components/breadcrumb/breadcrumb.js";
import "@web.awesome.me/webawesome-pro/dist/components/breadcrumb-item/breadcrumb-item.js";
import "@web.awesome.me/webawesome-pro/dist/components/icon/icon.js";
import "@web.awesome.me/webawesome-pro/dist/components/scroller/scroller.js";

const LUCIDE_BASE_URL =
  "https://cdn.jsdelivr.net/npm/lucide-static@0.577.0/icons";

registerIconLibrary("lucide", {
  resolver: (name) => `${LUCIDE_BASE_URL}/${name}.svg`,
  mutator: (svg) =>
    svg.querySelectorAll("path").forEach((path) => {
      path.setAttribute("fill", "none");
      path.setAttribute("stroke", "currentColor");
    }),
});
